var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("mask", {
  id: "UpDown_svg__a",
  width: 6,
  height: 12,
  x: 5,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.64 5.527 8 3.887l-1.647 1.64a.664.664 0 1 1-.94-.94l2.114-2.12a.664.664 0 0 1 .94 0l2.113 2.12a.664.664 0 1 1-.94.94m-3.28 4.946L8 12.113l1.647-1.633a.664.664 0 1 1 .94.94l-2.114 2.113c-.26.26-.68.26-.94 0l-2.113-2.12a.664.664 0 1 1 .94-.94",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#UpDown_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M0 0h16v16H0z"
})))));
export { SvgUpDown as ReactComponent };
export default __webpack_public_path__ + "UpDown.bc76eda3.svg";